import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const Pallets48x40Page = lazy(() => import('../pages/pallets-48x40/page'));
const CustomPalletsPage = lazy(() => import('../pages/custom-pallets/page'));
const PalletRemovalPage = lazy(() => import('../pages/pallet-removal/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/buy-48x40-pallets-nationwide',
    element: <Pallets48x40Page />,
  },
  {
    path: '/buy-custom-pallets-nationwide',
    element: <CustomPalletsPage />,
  },
  {
    path: '/pallet-removal-nationwide',
    element: <PalletRemovalPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;